
import React, { useEffect, useState } from "react";
import RenterForm from "./RenterForm";
import { fetchAPI } from "@/utility/NetworkUtils";
import Modal from "react-modal";

const InventoryFormModal = ({
  onClose,
  open,
  user,
  id
}) => {
  const [ loading, setLoading ] = useState(true);
  const [ renter, setRenter ] = useState(null);
  
  useEffect(() => {
    if(open) {
      if(id) {
        fetchRenter()
      }else {
        setLoading(false)
        setRenter(null)
      }
    }else {
      setRenter(null)
      setLoading(true)
    }
  },[open, id])

  const fetchRenter = async () => {
    fetchAPI(`/webapi/renters/${id}`, (json)=> {
      if (!json.errors) {
        setRenter(json.renter)
        setLoading(false)
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  }


  return (
    <Modal
      className="react-modal sg-receiving-list-modal"
      overlayClassName="react-modal-overlay"
      isOpen={open}
      onRequestClose={onClose}
    >
      {loading ? (
        <h1>
          Loading
        </h1>
      ): (
        <>
          <RenterForm
            renter={renter}
            user={user}
            onCancel={onClose}
            onSubmit={()=>{
              //Reload Page
              window.location.reload();
            }}
          />
        </>
      )}
    </Modal>
  )

}

export default InventoryFormModal